import {httpService} from "@/modules/common/services";

const getChannels = async (client_uid) => {
  return httpService.get(`/business/messaging/v1/channels/contacts/${client_uid}`, {new_api: true})
}

const getBusinessChannels = async () => {
  return httpService.get(`/business/messaging/v1/channels/contacts/ `, {new_api: true})
}


export default {
  getChannels,
  getBusinessChannels

}

